export const productos = [
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "0540005",
    descripcion_prod: "MINI GEL AROMATERAPIA 100ML",
    descripcion_corta: "MINI GEL AROMATERAPIA 100ML",
    descripcion_larga:
      "Gel de textura cremosa que al entrar en contacto con la piel proporciona una delicada y envolvente sensación. Deja la piel suave e hidratada, con una sensación de limpieza muy agradable. Su versión mini es perfecta para cuidar tu piel donde quiera que vayas.",
    psrecio_DIS: "2.79",
    precio_CON: "3.99",
    existencia: "1470",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Gel, jabón, portátil, ducha, natural, Instituto Español",
    promocion: [],
    imagen: ["0540005.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "0540007",
    descripcion_prod: "MINI GEL ROSA MOSQUETA 100ML",
    descripcion_corta: "MINI GEL ROSA MOSQUETA 100ML",
    descripcion_larga:
      "Una intensa hidratación a la piel que ayuda a retardar el proceso de envejecimiento y aporta elasticidad. Este gel crema está especialmente indicado para toda la familia y para pieles sensibles. Su versión mini es perfecta para cuidar tu piel donde quiera que vayas.",
    psrecio_DIS: "2.79",
    precio_CON: "3.99",
    existencia: "238",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Gel crema, jabón, estrías, elasticidad, portátil, Instituto Español",
    promocion: [],
    imagen: ["0540007.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "074",
    descripcion_sublinea: "CUIDADO - PIEL ATÓPICA",
    producto_id: "0540008",
    descripcion_prod: "MINI LECHE ATOPICAS 100ML",
    descripcion_corta: "MINI LECHE PIELES ATOPICAS 100ML",
    descripcion_larga:
      "Tratamiento específico que disminuye la sequedad cutánea en pieles atópicas e hipersensibles, gracias a sus excelentes propiedades antidescamativas, hidratantes y emolientes que la piel atópica requiere. Su versión mini es perfecta para cuidar tu piel donde quiera que vayas.",
    psrecio_DIS: "3.39",
    precio_CON: "4.85",
    existencia: "1649",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Loción, piel atópica, piel sensible, irritación, rash, portátil, Instituto Español",
    promocion: [],
    imagen: ["0540008.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "057",
    descripcion_sublinea: "HIGIENE - GEL ÍNTIMO",
    producto_id: "0540009",
    descripcion_prod: "MINI GEL INTIMO 100ML",
    descripcion_corta: "MINI GEL INTIMO 100ML",
    descripcion_larga:
      "Fórmula estudiada dermatológicamente que ayuda a proteger la piel de posibles irritaciones y consiguiendo una hidratación natural en la zona íntima, así como una agradable sensación de frescor y bienestar durante todo el día. Su versión mini es perfecta para cuidar tu piel donde quiera que vayas.",
    psrecio_DIS: "2.97",
    precio_CON: "4.25",
    existencia: "22",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Portátil, higiene íntima, Instituto Español",
    promocion: [],
    imagen: ["0540009.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "057",
    descripcion_sublinea: "HIGIENE - GEL ÍNTIMO",
    producto_id: "0540010",
    descripcion_prod: "MINI INTIMO PIEL SANA 100ML",
    descripcion_corta: "MINI GEL INTIMO PIEL SANA 100ML",
    descripcion_larga:
      "Antibacterial, indicado para toda la familia (pre-adolescentes en adelante) y es muy beneficiosa para la piel seca y sensible - ayuda a tener una piel más saludable y sana. Su versión mini es perfecta para cuidar tu piel donde quiera que vayas.",
    psrecio_DIS: "2.97",
    precio_CON: "4.25",
    existencia: "440",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Portátil, higiene íntima, Instituto Español",
    promocion: [],
    imagen: ["0540010.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "052",
    descripcion_sublinea: "HIGIENE - ROLL-ON",
    producto_id: "0540256",
    descripcion_prod: "ROLL-ON PIEL SANA 75 ML",
    descripcion_corta: "ROLL-ON PIEL SANA 75 ML",
    descripcion_larga:
      "Dermo, extra hidratante y suavizante, con acción antitranspirante de hasta 48 horas. HIDRATANTES DE ORIGEN 100% NATURAL.",
    psrecio_DIS: "5.07",
    precio_CON: "7.25",
    existencia: "3259",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Roll-on, desodorante, natural, piel sensible, Instituto Español",
    promocion: [],
    imagen: ["0540256.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "057",
    descripcion_sublinea: "HIGIENE - GEL ÍNTIMO",
    producto_id: "0540259",
    descripcion_prod: "GEL INTIMO PIEL SANA 300ML",
    descripcion_corta: "GEL INTIMO PIEL SANA 300ML",
    descripcion_larga:
      "Antibacterial, indicado para toda la familia (pre-adolescentes en adelante) y es muy beneficiosa para la piel seca y sensible - ayuda a tener una piel más saludable y sana.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "884",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Higiene íntima, pre-adolescente, Instituto Español",
    promocion: [],
    imagen: ["0540259.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "059",
    descripcion_sublinea: "HIGIENE - PIEL ATÓPICA",
    producto_id: "0540526",
    descripcion_prod: "GEL INTIMO ATOPICAS 300ML",
    descripcion_corta: "GEL INTIMO PIELES ATOPICAS 300ML",
    descripcion_larga:
      "Su fórmula mantiene el pH natural de la piel, proporciona excelentes propiedades protectoras, higiénicas, hidratantes y refrescantes. Sus propiedades emolientes y suavizantes previenen las irritaciones provocadas por diferentes motivos, reduciendo el picor y la sensación de malestar.",
    psrecio_DIS: "8.75",
    precio_CON: "12.50",
    existencia: "514",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Instituto Españo, higiene íntima, piel atópica, piel sensible, alergias",
    promocion: [],
    imagen: ["0540526.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "0544213",
    descripcion_prod: "GEL CREMA DE ALMENDRAS 750ML",
    descripcion_corta: "GEL CREMA DE ALMENDRAS 750ML",
    descripcion_larga:
      "Gel cremoso que hidrata la piel en profundidad. Suave y fácil de aclarar, su espuma libera un aroma relajante de notas envolventes. Además ayuda a fortalecer y proteger la piel.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "616",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Gel crema, aromaterapia, Instituto Español, jabón",
    promocion: [],
    imagen: ["0544213.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "052",
    descripcion_sublinea: "HIGIENE - ROLL-ON",
    producto_id: "0544510",
    descripcion_prod: "ROLL-ON ROSA MOSQUETA 75ML",
    descripcion_corta: "ROLL-ON ROSA MOSQUETA 75ML",
    descripcion_larga:
      "La Rosa Mosqueta tiene una gran propiedad, revigoriza las células productoras de colágeno, elastina y ácido hialurónico, responsables de la firmeza y elasticidad de la piel. Sin alcohol.",
    psrecio_DIS: "5.07",
    precio_CON: "7.25",
    existencia: "2647",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Roll-on, desodorante, Instituto Español",
    promocion: [],
    imagen: ["0544510.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "052",
    descripcion_sublinea: "HIGIENE - ROLL-ON",
    producto_id: "05482",
    descripcion_prod: "ROLL-ON AVENA 75ML",
    descripcion_corta: "ROLL-ON AVENA 75ML",
    descripcion_larga:
      "Este desodorante contiene los principales componentes nutritivos de la Avena, neutralizando los malos olores y proporcionando una agradable sensación de frescor durante todo el día. Es suave, ideal para todo tipo de pieles. No irrita la piel ya que no contiene alcohol.",
    psrecio_DIS: "5.01",
    precio_CON: "7.15",
    existencia: "6915",
    marca_id: "00",
    marca_descripcion: "SIN MARCA",
    tipo_incentivo_id: "",
    keywords: "Desodorante, roll on, piel madura, Instituto Español",
    promocion: [],
    imagen: ["05482.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "05484",
    descripcion_prod: "GEL DE DUCHA DE AVENA 750ML",
    descripcion_corta: "GEL DE DUCHA DE AVENA 750ML",
    descripcion_larga:
      "El Gel de Ducha de Avena facilita el cuidado de la piel, hidratándola al mismo tiempo que la nutre y limpia. Además le proporciona la elasticidad que una piel sana necesita a diario. Excelente en pieles maduras, sensibles o resecas.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "1886",
    marca_id: "00",
    marca_descripcion: "SIN MARCA",
    tipo_incentivo_id: "",
    keywords: "Gel, ducha, jabón, piel madura, Instituto Español",
    promocion: [],
    imagen: ["05484.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "054",
    descripcion_sublinea: "HIGIENE - BEBÉ",
    producto_id: "054865",
    descripcion_prod: "GEL DE BAÑO BEBÉ 500ML",
    descripcion_corta: "GEL DE BAÑO BEBÉ 500ML",
    descripcion_larga:
      "Higiene natural desde el primer día. Su fórmula sin jabón hidrata y calma la piel de tu bebé gracias a sus activos naturales, sin parabenos ni alérgenos. Testado pediátrica, dermatológica y oftalmológicamente. Apto para pieles sensibles y atópicas. Uso diario. Sin lágrimas.",
    psrecio_DIS: "10.49",
    precio_CON: "14.98",
    existencia: "246",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Bebé, niños, sin jabón, testado, piel sensible, piel atópica, Instituto Español",
    promocion: [],
    imagen: ["054865.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "054866",
    descripcion_prod: "GEL CREMA DE VAINILLA 750ML",
    descripcion_corta: "GEL CREMA DE VAINILLA 750ML",
    descripcion_larga:
      "Combina las propiedades nutritivas de la leche con los beneficios de la vainilla, limpiando la piel de forma natural y dejando un delicado aroma.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "719",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Gel crema, jabón, aromaterapia, Instituto Español",
    promocion: [],
    imagen: ["054866.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "054867",
    descripcion_prod: "GEL DE BAÑO COCO 750ML",
    descripcion_corta: "GEL DE BAÑO DE COCO 750ML",
    descripcion_larga:
      "Sumérgete en un baño de sensaciones con el gel Coco de Instituto Español. Aporta propiedades nutritivas e hidratantes para tu piel. Limpia tu piel a la vez que la nutre, dejándola hidratada durante todo el día. 0% Parabenos, relajante, nutre y purifica, protege y respeta tu piel.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "1019",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Jabón, gel, piel seca, Instituto Español",
    promocion: [],
    imagen: ["054867.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "054868",
    descripcion_prod: "GEL DUCHA LACTOADVANCE 750ML",
    descripcion_corta: "GEL DE DUCHA LACTOADVANCE 750ML",
    descripcion_larga:
      "Comienza un día perfecto con una relajante ducha con Lacto Advance que proporciona una extraordinaria hidratación, dejando tu piel más sedosa que nunca. Tu piel perfectamente hidratada, cuidada y suave. Testado dermatológicamente. No tiene parabenos y es 100% apto veganos.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "1842",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Gel, ducha, jabón, piel joven, leche, Instituto Español",
    promocion: [],
    imagen: ["054868.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "0502",
    descripcion_sublinea: "HIGIENE - CORPORAL",
    producto_id: "054870",
    descripcion_prod: "GEL CARE 650ML",
    descripcion_corta: "GEL CARE 650ML",
    descripcion_larga: "GEL CARE 650ML",
    psrecio_DIS: "6.66",
    precio_CON: "9.50",
    existencia: "842",
    marca_id: "197",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["054870.webp"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "052",
    descripcion_sublinea: "HIGIENE - ROLL-ON",
    producto_id: "054877",
    descripcion_prod: "ROLL-ON LACTOADVANCE 75ML",
    descripcion_corta: "ROLL-ON LACTOADVANCE 75ML",
    descripcion_larga:
      "Nuestro desodorante se caracteriza porque no mancha la ropa, reduce la transpiración y el mal olor, no lleva alcohol y, además, puede usarse en todo tipo de pieles. Sin lactosa y apto para veganos.",
    psrecio_DIS: "5.01",
    precio_CON: "7.15",
    existencia: "7763",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Desodorante, roll on, leche, Instituto Español",
    promocion: [],
    imagen: ["054877.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "052",
    descripcion_sublinea: "HIGIENE - ROLL-ON",
    producto_id: "054879",
    descripcion_prod: "GEL INTIMO ODOR BLOCK 300ML",
    descripcion_corta: "GEL INTIMO ODOR BLOCK 300ML",
    descripcion_larga:
      "El Gel Íntimo Odor Block está indicado para la higiene y el cuidado femeninos. Aporta una agradable sensación de frescor y bienestar durante 24 horas. Ayuda a neutralizar el olor y protege de posibles irritaciones. Su fórmula íntima está estudiada dermatológicamente.",
    psrecio_DIS: "4.89",
    precio_CON: "6.99",
    existencia: "946",
    marca_id: "55",
    marca_descripcion: "VOGUEPARIS",
    tipo_incentivo_id: "p",
    keywords: "Jabón, olor, zona íntima, Instituto Español",
    promocion: {
      tipo_promocion: "DESC",
      descuento: "26%",
      precio_regular: "9.5",
    },
    imagen: ["054879.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "059",
    descripcion_sublinea: "HIGIENE - PIEL ATÓPICA",
    producto_id: "054880",
    descripcion_prod: "ROLL-ON PIELES ATOPICAS 75ML",
    descripcion_corta: "ROLL-ON PIELES ATOPICAS 75ML",
    descripcion_larga:
      "Formulado para el cuidado y la protección de la piel extra sensible e intolerante, evita la irritación y el picor. Su fórmula sin activos potencialmente alergénicos o irritantes en pieles sensibles, aseguran una acción desodorante fresca y duradera. No contiene alcohol, aluminio ni parabenos.",
    psrecio_DIS: "7.18",
    precio_CON: "10.25",
    existencia: "235",
    marca_id: "55",
    marca_descripcion: "VOGUEPARIS",
    tipo_incentivo_id: "",
    keywords:
      "Roll-on, desodorante, sin aluminio, piel atópica, piel sensible, Instituto Español",
    promocion: [],
    imagen: ["054880.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "059",
    descripcion_sublinea: "HIGIENE - PIEL ATÓPICA",
    producto_id: "056658",
    descripcion_prod: "GEL DUCHA ATOPICAS 500 ML",
    descripcion_corta: "GEL DE DUCHA PIELES ATOPICAS 500 ML",
    descripcion_larga:
      "Protege y calma los síntomas característicos de las pieles sensibles, secas y atópicas, por lo que prolonga el tiempo entre brotes. Minimiza los riesgos de reacciones alérgicas. Su base extra suave limpia sin irritar, y su acción hidratante favorece la elasticidad y tersura de la piel.",
    psrecio_DIS: "11.89",
    precio_CON: "16.98",
    existencia: "69",
    marca_id: "24",
    marca_descripcion: "VOGUE D PARIS",
    tipo_incentivo_id: "",
    keywords: "Gel, jabón, piel atópica, piel sensible, Instituto Español",
    promocion: [],
    imagen: ["056658.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "056659",
    descripcion_prod: "GEL DUCHA AROMATERAPIA 750 ML",
    descripcion_corta: "GEL DE DUCHA AROMATERAPIA 750ML",
    descripcion_larga:
      "Gel de textura cremosa que al entrar en contacto con la piel proporciona una delicada y envolvente sensación. Deja la piel suave e hidratada, con una sensación de limpieza muy agradable.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "323",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Gel, jabón, ducha, natural, Instituto Español",
    promocion: [],
    imagen: ["056659.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "053",
    descripcion_sublinea: "HIGIENE - GEL DE BAÑO",
    producto_id: "056660",
    descripcion_prod: "GEL CREMA ROSA MOSQUETA 750ML",
    descripcion_corta: "GEL CREMA ROSA MOSQUETA 750ML",
    descripcion_larga:
      "Una intensa hidratación a la piel que ayuda a retardar el proceso de envejecimiento y aporta elasticidad. Este gel crema está especialmente indicado para toda la familia y para pieles sensibles.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "158",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Gel crema, jabón, elasticidad, piel sensible, estrías, embarazo, Instituto Español",
    promocion: [],
    imagen: ["056660.png"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "056",
    descripcion_sublinea: "HIGIENE - MANOS",
    producto_id: "059002",
    descripcion_prod: "ANATOLIAN FIG LIQUID SOAP 500ML",
    descripcion_corta: "ANATOLIAN FIG LIQUID SOAP 500ML",
    descripcion_larga: "",
    psrecio_DIS: "2.79",
    precio_CON: "3.99",
    existencia: "482",
    marca_id: "205",
    marca_descripcion: "DEEP FRESH",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["059002.webp"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "0502",
    descripcion_sublinea: "HIGIENE - CORPORAL",
    producto_id: "059003",
    descripcion_prod: "GEL EXFOLIANTE COCO & CAFÉ",
    descripcion_corta: "GEL EXFOLIANTE COCO & CAFÉ",
    descripcion_larga: "GEL EXFOLIANTE COCO & CAFÉ",
    psrecio_DIS: "4.54",
    precio_CON: "6.50",
    existencia: "405",
    marca_id: "205",
    marca_descripcion: "DEEP FRESH",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["059003.webp"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "0502",
    descripcion_sublinea: "HIGIENE - CORPORAL",
    producto_id: "059007",
    descripcion_prod: "DEO WIPES FRESH LADY 20 U",
    descripcion_corta: "DEO WIPES FRESH LADY 20 U",
    descripcion_larga: "DEO WIPES FRESH LADY 20 U",
    psrecio_DIS: "1.39",
    precio_CON: "1.99",
    existencia: "4658",
    marca_id: "205",
    marca_descripcion: "DEEP FRESH",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["059007.webp"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "0502",
    descripcion_sublinea: "HIGIENE - CORPORAL",
    producto_id: "059009",
    descripcion_prod: "JABÓN LIQUIDO ACEITE DE OLIVA 500ML",
    descripcion_corta: "JABÓN LIQUIDO ACEITE DE OLIVA 500ML",
    descripcion_larga: "JABÓN LIQUIDO ACEITE DE OLIVA 500ML",
    psrecio_DIS: "3.49",
    precio_CON: "4.99",
    existencia: "647",
    marca_id: "205",
    marca_descripcion: "DEEP FRESH",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["059009.webp"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "054",
    descripcion_sublinea: "HIGIENE - BEBÉ",
    producto_id: "059010",
    descripcion_prod: "WIPES EXTRA SUAVES BEBÉ 72 U",
    descripcion_corta: "WIPES EXTRA SUAVES BEBÉ 72 U",
    descripcion_larga: "WIPES EXTRA SUAVES BEBÉ 72 U",
    psrecio_DIS: "1.99",
    precio_CON: "2.85",
    existencia: "1449",
    marca_id: "205",
    marca_descripcion: "DEEP FRESH",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["059010.webp"],
  },
  {
    linea_id: "05",
    categoria: "HIGIENE",
    sublinea_id: "0502",
    descripcion_sublinea: "HIGIENE - CORPORAL",
    producto_id: "059011",
    descripcion_prod: "WIPES PARA ADULTOS 48 U",
    descripcion_corta: "WIPES PARA ADULTOS 48 U",
    descripcion_larga: "WIPES PARA ADULTOS 48 U",
    psrecio_DIS: "3.49",
    precio_CON: "4.99",
    existencia: "1037",
    marca_id: "205",
    marca_descripcion: "DEEP FRESH",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["059011.webp"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "07485",
    descripcion_prod: "LOCION DE AVENA 500ML",
    descripcion_corta: "LOCION DE AVENA 500ML",
    descripcion_larga:
      "Excelente en pieles maduras, sensibles o resecas, ya que cuenta con propiedades calmantes, emolientes e hidratantes; que recuperan la elasticidad.",
    psrecio_DIS: "6.76",
    precio_CON: "9.65",
    existencia: "3855",
    marca_id: "00",
    marca_descripcion: "SIN MARCA",
    tipo_incentivo_id: "",
    keywords: "Loción, crema, hidratante, piel madura, Instituto Español",
    promocion: [],
    imagen: ["07485.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074864",
    descripcion_prod: "LOCION ARNICA 500ML",
    descripcion_corta: "LOCION ARNICA PIERNAS CANSADAS 500ML",
    descripcion_larga:
      "Esta loción energizante con extracto de flores de Árnica relaja, tonifica y rejuvenece las piernas cansadas. Ayuda a mantener el equilibrio de hidratación ideal de la piel, dejando las piernas suaves y refrescadas.",
    psrecio_DIS: "7.81",
    precio_CON: "11.15",
    existencia: "1088",
    marca_id: "24",
    marca_descripcion: "VOGUE D PARIS",
    tipo_incentivo_id: "",
    keywords: "Várices, piernas cansadas, Instituto Español",
    promocion: [],
    imagen: ["074864.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074865",
    descripcion_prod: "MINI LOCION ARNICA 100ML",
    descripcion_corta: "MINI LOCIÓN ARNICA PIERNAS CANSADAS 100ML",
    descripcion_larga:
      "Esta loción energizante con extracto de flores de Árnica relaja, tonifica y rejuvenece las piernas cansadas. Ayuda a mantener el equilibrio de hidratación ideal de la piel, dejando las piernas suaves y refrescadas.",
    psrecio_DIS: "2.97",
    precio_CON: "4.25",
    existencia: "147",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Várices, piernas cansadas, portátil, Instituto Español",
    promocion: [],
    imagen: ["074865.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074866",
    descripcion_prod: "MINI LOCION DE AVENA 100ML",
    descripcion_corta: "MINI LOCION DE AVENA 100ML",
    descripcion_larga: "",
    psrecio_DIS: "2.97",
    precio_CON: "4.25",
    existencia: "394",
    marca_id: "24",
    marca_descripcion: "VOGUE D PARIS",
    tipo_incentivo_id: "",
    keywords:
      "Loción, crema, hidratante, piel madura, portátil, Instituto Español",
    promocion: [],
    imagen: ["074866.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "075",
    descripcion_sublinea: "CUIDADO - TARRO",
    producto_id: "074870",
    descripcion_prod: "TARRO ROSA MOSQUETA 400ML",
    descripcion_corta: "TARRO ROSA MOSQUETA 400ML",
    descripcion_larga:
      "La Crema Regeneradora Rosa Mosqueta ayuda con la hidratación a la vez que reafirma tu piel. La Rosa Mosqueta es pieza clave para la prevención de estrías, esta fórmula esta además enriquecida con ácido hialurónico para potenciar los beneficios de la Rosa Mosqueta.",
    psrecio_DIS: "10.49",
    precio_CON: "14.98",
    existencia: "301",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Crema, hidratante, estrías, embarazo, Instituto Español",
    promocion: [],
    imagen: ["074870.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "0711",
    descripcion_sublinea: "CUIDADO - BEBÉ",
    producto_id: "074874",
    descripcion_prod: "LOCION HIDRATANTE BEBE 300ML",
    descripcion_corta: "LOCION HIDRATANTE BEBE 300ML",
    descripcion_larga:
      "Loción ligera de fácil absorción. Su fórmula con activos naturales contribuye al excelente cuidado y suavidad de la piel, incluso en recién nacidos. Apta para pieles sensibles y atópicas. Válvula sin contacto, que no contamina el producto. Testado pediátrica, dermatológica y oftalmológicamente.",
    psrecio_DIS: "11.37",
    precio_CON: "16.25",
    existencia: "147",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Bebé, niños, hidratante, recién nacido, Instituto Español",
    promocion: [],
    imagen: ["074874.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074875",
    descripcion_prod: "LOCION LACTOADVANCE 500ML",
    descripcion_corta: "LOCION LACTOADVANCE 500ML",
    descripcion_larga:
      "Loción que nutre la piel dejando una sensación de profundo bienestar. Absorción inmediata sin textura grasa que deja una suavidad extraordinaria. Apto para veganos y celíacos.",
    psrecio_DIS: "6.76",
    precio_CON: "9.65",
    existencia: "5580",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Hidratante, crema, piel joven, leche, Instituto Español",
    promocion: [],
    imagen: ["074875.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074876",
    descripcion_prod: "MINI LOCION LACTOADVANCE 100ML",
    descripcion_corta: "MINI LOCION LACTOADVANCE 100ML",
    descripcion_larga:
      "Loción que nutre la piel dejando una sensación de profundo bienestar. Absorción inmediata sin textura grasa que deja una suavidad extraordinaria. Apto para veganos y celíacos. Su versión mini es perfecta para tu bolso para mantener tu piel siempre suave e hidratada.",
    psrecio_DIS: "2.97",
    precio_CON: "4.25",
    existencia: "260",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Hidratante, crema, piel joven, leche, portátil, Instituto Español",
    promocion: [],
    imagen: ["074876.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "076",
    descripcion_sublinea: "CUIDADO - ACEITE",
    producto_id: "074878",
    descripcion_prod: "ACEITE DE ARGAN 250ML",
    descripcion_corta: "ACEITE CORPORAL DE ARGAN 250ML",
    descripcion_larga:
      "Aceite hidratante, ayuda a luchar contra la sequedad de la piel, estimula la oxigenación celular, alivia la piel dañada o irritada. Puede usarse en baños aromáticos, duchas hidratantes o en masajes para una sensación relajante y de bienestar. Se puede aplicar sobre la piel mojada, húmeda o seca.",
    psrecio_DIS: "7.35",
    precio_CON: "10.50",
    existencia: "1590",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Corporal, hidratante, Instituto Español",
    promocion: [],
    imagen: ["074878.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074879",
    descripcion_prod: "LOCIÓN DE COCO 500ML",
    descripcion_corta: "LOCION DE COCO 500ML",
    descripcion_larga:
      "Cuida y protege tu piel con la loción corporal Coco de Instituto Español. Suaviza e hidrata en profundidad mientras su fragancia aporta bienestar. Sentirás tu piel protegida, restaurada y extremadamente suave.",
    psrecio_DIS: "6.66",
    precio_CON: "9.50",
    existencia: "1500",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Crema, hidratante, piel seca, Instituto Español",
    promocion: [],
    imagen: ["074879.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "076",
    descripcion_sublinea: "CUIDADO - ACEITE",
    producto_id: "074880",
    descripcion_prod: "ACEITE ROSA MOSQUETA 250ML",
    descripcion_corta: "ACEITE CORPORAL ROSA MOSQUETA 250ML",
    descripcion_larga:
      "La Rosa Mosqueta revigoriza las células productoras de colágeno, elastina y ácido hialurónico, responsables de la firmeza y elasticidad de la piel. Puede usarlo con la piel mojada después de la ducha, extender el aceite y secarlo con la toalla. Quedará el aroma tanto en su piel como en la toalla.",
    psrecio_DIS: "7.70",
    precio_CON: "10.99",
    existencia: "427",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords: "Corporal, hidratante, estrías, embarazo, Instituto Español",
    promocion: [],
    imagen: ["074880.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "074",
    descripcion_sublinea: "CUIDADO - PIEL ATÓPICA",
    producto_id: "074882",
    descripcion_prod: "CREMA DE MANOS ATÓPICAS",
    descripcion_corta: "CREMA MANOS PIELES ATOPICAS 75ML",
    descripcion_larga:
      "Cuida y protege la piel, previene la sequedad y rehidrata las manos secas y estropeadas del uso diario gracias a sus ingredientes activos con propiedades anti-pruriginosas, anti-inflamatorias y anti-radicales, aliviando la irritación y el picor al mismo tiempo que protege y suaviza la piel.",
    psrecio_DIS: "5.59",
    precio_CON: "7.99",
    existencia: "140",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Piel atópica, piel sensible, rash, irritación, alergias, alcohol en gel, Instituto Español",
    promocion: [],
    imagen: ["074882.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "076",
    descripcion_sublinea: "CUIDADO - ACEITE",
    producto_id: "074889",
    descripcion_prod: "ACEITE DE COCO 250ML",
    descripcion_corta: "ACEITE CORPORAL DE COCO 250ML",
    descripcion_larga:
      "El Aceite corporal Coco, incorpora las propiedades naturales y cosméticas del coco, que proporcionan un aporte extra de hidratación, logrando que la piel se mantenga suave, sana y tersa. Especialmente recomendado en pieles secas. Se puede aplicar sobre la piel mojada, húmeda o seca.",
    psrecio_DIS: "7.70",
    precio_CON: "10.99",
    existencia: "1281",
    marca_id: "55",
    marca_descripcion: "VOGUEPARIS",
    tipo_incentivo_id: "",
    keywords: "Corporal, hidratante, piel seca, Instituto Español",
    promocion: [],
    imagen: ["074889.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074890",
    descripcion_prod: "LOCIÓN COLÁGENO 500ML",
    descripcion_corta: "LOCIÓN COLÁGENO 500ML",
    descripcion_larga:
      "El colágeno favorece la reducción y prevención de arrugas, le da firmeza y flexibilidad a la piel. Además, es un excelente agente hidratante para la epidermis, favoreciendo su limpieza y ayudándola a combatir los radicales libres y polución ambiental.",
    psrecio_DIS: "11.19",
    precio_CON: "15.99",
    existencia: "1082",
    marca_id: "55",
    marca_descripcion: "VOGUEPARIS",
    tipo_incentivo_id: "",
    keywords: "Hidratante, crema, antiedad, Instituto Español",
    promocion: [],
    imagen: ["074890.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "074891",
    descripcion_prod: "LOCIÓN DBTS 500ML",
    descripcion_corta: "LOCIÓN DBTS 500ML",
    descripcion_larga:
      "La Loción DBTs alivia los síntomas y molestias de la sequedad, proporciona una acción emoliente y contribuye a la regeneración de la epidermis. La fórmula aporta actividad como protector vascular y venotónico, actividad antioxidante y excelentes propiedades antinflamatorias.",
    psrecio_DIS: "10.67",
    precio_CON: "15.24",
    existencia: "788",
    marca_id: "55",
    marca_descripcion: "VOGUEPARIS",
    tipo_incentivo_id: "",
    keywords: "Diabetes, piel sensible, piel seca, Instituto Español",
    promocion: [],
    imagen: ["074891.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "076",
    descripcion_sublinea: "CUIDADO - ACEITE",
    producto_id: "074892",
    descripcion_prod: "ACEITE DE ARNICA 250ML",
    descripcion_corta: "ACEITE CORPORAL DE ARNICA 250ML",
    descripcion_larga:
      "Libera las tensiones musculares y reanima tu cuerpo con el aceite de Árnica. Su fórmula está diseñada para calmar y aliviar los dolores de tu piel. Brinda profunda hidratación, calma y suaviza el dolor. Se puede aplicar sobre la piel mojada, húmeda o seca. Apto para veganos y para celiacos.",
    psrecio_DIS: "5.59",
    precio_CON: "7.99",
    existencia: "1245",
    marca_id: "55",
    marca_descripcion: "VOGUEPARIS",
    tipo_incentivo_id: "p",
    keywords:
      "Corporal, hidratante, várices, piernas cansadas, Instituto Español",
    promocion: {
      tipo_promocion: "DESC",
      descuento: "27%",
      precio_regular: "10.99",
    },
    imagen: ["074892.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "079",
    descripcion_sublinea: "CUIDADO - ÓLEO",
    producto_id: "0754001",
    descripcion_prod: "BÁLSAMO RESPIRAR BIEN 10ML",
    descripcion_corta: "BÁLSAMO RESPIRAR BIEN 10ML",
    descripcion_larga:
      "Bálsamo para respirar mejor con aceites esenciales de eucalipto, tomillo y menta. Descongestiona, despeja la respiración, relaja, purifica y brinda bienestar en época invernal. Recomendado para toda la familia.",
    psrecio_DIS: "3.85",
    precio_CON: "5.50",
    existencia: "399",
    marca_id: "174",
    marca_descripcion: "GIGOT",
    tipo_incentivo_id: "",
    keywords: "Óleo, descongestiona, natural, Gigot, aceite esencial, difusor",
    promocion: [],
    imagen: ["0754001.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "077",
    descripcion_sublinea: "CUIDADO - PIEL",
    producto_id: "0754003",
    descripcion_prod: "CICATRIFIN OIL 25ML",
    descripcion_corta: "CICATRIFIN OIL 25ML",
    descripcion_larga:
      "Óleo concentrado reparador con aceite de Purcelina. Regenera la piel severamente agrietada, repara, humecta, nutre y ayuda a suavizar la apariencia de cicatrices y estrías. Hidratante y emoliente, aporta suavidad a toda la piel del cuerpo. Mejora la elasticidad de la piel dándole mayor resistencia.",
    psrecio_DIS: "6.12",
    precio_CON: "8.75",
    existencia: "489",
    marca_id: "174",
    marca_descripcion: "GIGOT",
    tipo_incentivo_id: "",
    keywords: "Cicatrices, estrías, Gigot",
    promocion: [],
    imagen: ["0754003.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "077",
    descripcion_sublinea: "CUIDADO - PIEL",
    producto_id: "0754004",
    descripcion_prod: "CREMA BLANQUEADORA 30G",
    descripcion_corta: "CREMA BLANQUEADORA ENTREPIERNAS 30G",
    descripcion_larga:
      "Crema dermoaclarante. Para uso específico en áreas de piel oscurecida por roce o irritación. Modo de uso: secar la piel y aplicar en la zona a tratar dos veces al día en forma continua y durante no menos de dos meses.",
    psrecio_DIS: "4.20",
    precio_CON: "6.99",
    existencia: "4513",
    marca_id: "174",
    marca_descripcion: "GIGOT",
    tipo_incentivo_id: "v",
    keywords: "Blanqueadora, manchas, roce, irritación, Gigot",
    promocion: {
      tipo_promocion: "DESC",
      descuento: "40%",
      precio_regular: "6.99",
    },
    imagen: ["0754004.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "079",
    descripcion_sublinea: "CUIDADO - ÓLEO",
    producto_id: "0754006",
    descripcion_prod: "ÓLEO ANTIESTRÉS 10ML",
    descripcion_corta: "ÓLEO ANTIESTRÉS 10ML",
    descripcion_larga: "ÓLEO ANTIESTRÉS 10ML",
    psrecio_DIS: "3.85",
    precio_CON: "5.50",
    existencia: "1349",
    marca_id: "174",
    marca_descripcion: "GIGOT",
    tipo_incentivo_id: "",
    keywords: "Aceite esencial, relaja, natural, Gigot, difusor",
    promocion: [],
    imagen: ["0754006.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "079",
    descripcion_sublinea: "CUIDADO - ÓLEO",
    producto_id: "0754007",
    descripcion_prod: "ÓLEO ENERGIZANTE 10ML",
    descripcion_corta: "ÓLEO ENERGIZANTE 10ML",
    descripcion_larga:
      "Óleo con aceites esenciales de naranja, lima, pomelo, azahar y jengibre. Activa el buen ánimo, ayuda a enfrentar con vitalidad y optimismo las actividades diarias y evita que nos invada la angustia y la tristeza. Disipa el cansancio y despierta sensaciones de felicidad y alegría.",
    psrecio_DIS: "3.85",
    precio_CON: "5.50",
    existencia: "199",
    marca_id: "174",
    marca_descripcion: "GIGOT",
    tipo_incentivo_id: "",
    keywords: "Aceite esencial, activa, alegría, natural, Gigot, difusor",
    promocion: [],
    imagen: ["0754007.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "079",
    descripcion_sublinea: "CUIDADO - ÓLEO",
    producto_id: "0754008",
    descripcion_prod: "ÓLEO RUDA 10ML",
    descripcion_corta: "ÓLEO RUDA 10ML",
    descripcion_larga:
      "Aceite esencial de ruda. Protege y armoniza la energía interior. La ruda es una hierba tradicional que se puede usar en ambientes contra hongos aéreos que causan alergias y enfermedades respiratorias. Además, es un poderoso repelente que evita varios parásitos domésticos.",
    psrecio_DIS: "2.27",
    precio_CON: "3.25",
    existencia: "395",
    marca_id: "174",
    marca_descripcion: "GIGOT",
    tipo_incentivo_id: "p",
    keywords: "Aceite esencial, enfermedad, repelente, natural, difusor, Gigot",
    promocion: {
      tipo_promocion: "DESC",
      descuento: "41%",
      precio_regular: "5.5",
    },
    imagen: ["0754008.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "0710",
    descripcion_sublinea: "CUIDADO - BIENESTAR",
    producto_id: "0754010",
    descripcion_prod: "POMADA PARA GOLPES Y MORETES",
    descripcion_corta: "POMADA BALSAMICA PARA GOLPES Y MORETES",
    descripcion_larga:
      "Alivio inmediato de golpes y moretones. Contiene árnica, enebro, sauce, menta y consuelda, que brindan acción antiinflamatoria, estimulan la circulación sanguínea y regeneran la piel afectada por un golpe. Evitan la formación de moretones y chichotes, desinflama y mejora rápidamente la piel.",
    psrecio_DIS: "6.29",
    precio_CON: "8.99",
    existencia: "624",
    marca_id: "174",
    marca_descripcion: "GIGOT",
    tipo_incentivo_id: "",
    keywords: "Moretón, alivio, natural, antiinflamatorio, Gigot",
    promocion: [],
    imagen: ["0754010.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "074",
    descripcion_sublinea: "CUIDADO - PIEL ATÓPICA",
    producto_id: "07680",
    descripcion_prod: "LOCION PIELES ATOPICAS 300ML",
    descripcion_corta: "LOCION CORPORAL PIELES ATOPICAS 300ML",
    descripcion_larga:
      "Disminuye la sequedad cutánea en pieles atópicas e hipersensibles gracias a sus excelentes propiedades anti descamativas, hidratantes y emolientes. Intensa hidratación, acción anti-sequedad y regeneración de las defensas naturales, aliviando la irritación y el picor.",
    psrecio_DIS: "11.19",
    precio_CON: "15.99",
    existencia: "333",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Loción, piel atópica, piel sensible, irritación, rash, Instituto Español",
    promocion: [],
    imagen: ["07680.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "073",
    descripcion_sublinea: "CUIDADO - LOCIÓN",
    producto_id: "07682",
    descripcion_prod: "LOCION ROSA MOSQUETA 500ML",
    descripcion_corta: "LOCION ROSA MOSQUETA 500ML",
    descripcion_larga:
      "Loción que estimula la hidratación y la elasticidad natural de la piel y ayuda a eliminar cicatrices y estrías. Revigoriza las células productoras de colágeno, elastina y ácido hialurónico para mayor firmeza y elasticidad de la piel. La potente combinación retrasa el envejecimiento de la piel.",
    psrecio_DIS: "7.45",
    precio_CON: "10.64",
    existencia: "1022",
    marca_id: "117",
    marca_descripcion: "INSTITUTO ESPAÑOL",
    tipo_incentivo_id: "",
    keywords:
      "Cicatrices, estrías, elasticidad, ácido hialurónico, embarazo, Instituto Español",
    promocion: [],
    imagen: ["07682.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "078",
    descripcion_sublinea: "CUIDADO - PROTECTOR SOLAR",
    producto_id: "0778001",
    descripcion_prod: "PROTECTOR SOLAR SPF30 120ML",
    descripcion_corta: "PROTECTOR SOLAR SPF30 120ML",
    descripcion_larga:
      "Protector solar para rostro y cuerpo con factor de protección SPF 30+ protege segura y eficazmente la piel de los rayos UVB y UVA. Con vitamina E, extracto de aloe vera, es el perfecto balance para proteger la piel mientras se hidrata, dejando un efecto suave y terso, y sin dejar sensación grasa.",
    psrecio_DIS: "8.75",
    precio_CON: "12.50",
    existencia: "456",
    marca_id: "204",
    marca_descripcion: "HEALTHY FAMILY",
    tipo_incentivo_id: "",
    keywords: "No graso, protector solar",
    promocion: [],
    imagen: ["0778001.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "0701",
    descripcion_sublinea: "CUIDADO - CORPORAL",
    producto_id: "0778002",
    descripcion_prod: "SACHET PROTECTOR SOLAR SPF30 10ML",
    descripcion_corta: "SACHET PROTECTOR SOLAR SPF30 10ML",
    descripcion_larga: "SACHET PROTECTOR SOLAR SPF30 10ML",
    psrecio_DIS: "0.35",
    precio_CON: "0.35",
    existencia: "373",
    marca_id: "204",
    marca_descripcion: "HEALTHY FAMILY",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["default.png"],
  },
  {
    linea_id: "07",
    categoria: "PRODUCTOS PARA LA PIEL",
    sublinea_id: "075",
    descripcion_sublinea: "CUIDADO - TARRO",
    producto_id: "079001",
    descripcion_prod: "CREMA DE ACEITE DE OLIVA 250ML",
    descripcion_corta: "CREMA DE ACEITE DE OLIVA 250ML",
    descripcion_larga: "CREMA DE ACEITE DE OLIVA 250ML",
    psrecio_DIS: "5.94",
    precio_CON: "8.50",
    existencia: "888",
    marca_id: "205",
    marca_descripcion: "DEEP FRESH",
    tipo_incentivo_id: "",
    keywords: "",
    promocion: [],
    imagen: ["079001.webp"],
  },
];
